module.exports = __webpack_public_path__ + "media/components/country-flag/static/tk-32336712768940cdbce8be2bd600d389.svg";